import { jwtDecode, JwtPayload } from 'jwt-decode';

export class JwtUtils {
  static decodeToken(token: string): JwtPayload | null {
    try {
      return jwtDecode(token);
    } catch (error) {
      return null;
    }
  }

  static isTokenExpired(token: string): boolean {
    if (!token) {
      return true;
    }
    const decoded = this.decodeToken(token);
    if (decoded && decoded.exp) {
      return decoded.exp * 1000 < Date.now();
    }
    return true;
  }
}
